import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Data, Router } from '@angular/router';
import { MASKS } from 'ng-brazil';
import { ContatoStatus } from 'src/app/models/contato-status';
import { CarregandoService } from 'src/app/services/carregando.service';
import { GlobalService } from 'src/app/services/global.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { ContatoStatusService } from 'src/app/services/contato-status.service';

@Component({
  selector: 'app-cadastrar-contato-status',
  templateUrl: './cadastrar-contato-status.component.html',
  styleUrls: ['./cadastrar-contato-status.component.scss']
})
export class CadastrarContatoStatusComponent implements OnInit {
  // variáveis
  idContatoStatus;
  contatoStatus = new ContatoStatus();
  editando = false;
  carregando = true;
  public MASKS = MASKS;
  editavel = true;
  padrao = false;
  pegouFranquia = false;
  tipos = [{ id: 0, nome: 'Normal' }, { id: 1, nome: 'Mercado Pago' }];
  tipo = 0;
  texto = 'Orçamento';

  constructor(private route: ActivatedRoute, private notificacaoService: NotificacaoService,
    private contatoStatusService: ContatoStatusService,
    private router: Router,
    private globalService: GlobalService, private carregandoService: CarregandoService) { }

  ngOnInit() {

    this.route.data.subscribe((data: Data) => {
      this.tipo = data['tipo'];
      this.texto = this.tipo === 0 ? 'Orçamento' : 'Repasse';

      // se for edição, busca o contatoStatus do id passado
      if (this.route.snapshot.paramMap.get('id')) {
        this.idContatoStatus = this.route.snapshot.paramMap.get('id');
        this.editando = true;
        this.buscarContatoStatus();
      } else {
        this.contatoStatus = new ContatoStatus();
        this.atualizaDadosContatoStatus();
      }
    });


  }

  ngAfterViewInit(): void {

  }

  buscarContatoStatus() {

    this.carregandoService.mostra('buscaContatoStatus');

    this.contatoStatusService.consultarPorId(this.idContatoStatus).subscribe(age => {
      this.contatoStatus = age;
      this.atualizaDadosContatoStatus();
    }, (erro) => {
      this.carregandoService.esconde('buscaContatoStatus');
      this.notificacaoService.erro(erro);
    });
  }

  atualizaDadosContatoStatus() {

    this.carregando = false;

    this.carregandoService.esconde('buscaContatoStatus');
  }

  salvar() {
    this.carregandoService.mostra('salvaContatoStatus');

    this.contatoStatus.tipo = this.tipo;
    this.contatoStatusService.salvar(this.contatoStatus).subscribe(() => {
      this.notificacaoService.sucesso('Status salvo com sucesso!!!');
      this.router.navigate(['configuracoes/contato-status']).then(() => {
        this.carregandoService.esconde('salvaContatoStatus');
      });

    }, (erro) => {
      this.carregandoService.esconde('salvaContatoStatus');
      this.notificacaoService.erro(erro);
    });
  }

  ngOnDestroy(): void { }
}
